document.addEventListener("DOMContentLoaded", async() => {

  let modalSourceCard = null;
    /* ---------- DELIVERY MODAL IMAGE SLIDER ---------- */
const ZONE_MAP_IMG = "https://cdn.shopify.com/s/files/1/0060/0801/2900/files/Installation-Zones-Map.png?v=1774243632";
const DLV_THUMB_VISIBLE = 5;
let dlvImages = [];
let dlvIndex = 0;
let dlvPos = 0;

function renderDeliveryThumbs(images) {
  const wrap = document.getElementById("deliveryThumbWrap");
  const track = document.getElementById("deliveryThumbTrack");
  const mainImg = document.querySelector("#deliveryModal .modal-image");
  if (!wrap || !track || !mainImg) return;

  dlvImages = images
    .filter(Boolean)
    .map((s) => (s.startsWith("//") ? "https:" + s : s));
  dlvIndex = 0;
  dlvPos = 0;
  track.innerHTML = "";
  track.style.transform = "translateX(0px)";

  if (!dlvImages.length) {
    wrap.style.display = "none";
    return;
  }

  mainImg.src = dlvImages[0];
  mainImg.style.display = "block";

  // Single image → no thumbnails/arrows
  if (dlvImages.length < 2) {
    wrap.style.display = "none";
    return;
  }

  wrap.style.display = "flex";
  dlvImages.forEach((src, i) => {
    const t = document.createElement("img");
    t.src = src;
    t.alt = "";
    t.className = "dlv-thumb-item" + (i === 0 ? " active" : "");
    t.dataset.index = i;
    track.appendChild(t);
  });
  updateDeliveryArrows();
}

function setDeliveryImage(index) {
  const track = document.getElementById("deliveryThumbTrack");
  const mainImg = document.querySelector("#deliveryModal .modal-image");
  if (!track || !mainImg) return;

  const items = track.querySelectorAll(".dlv-thumb-item");
  if (!items.length) return;

  dlvIndex = Math.max(0, Math.min(items.length - 1, index));
  items.forEach((t, i) => t.classList.toggle("active", i === dlvIndex));
  mainImg.src = dlvImages[dlvIndex];

  // keep active thumb in view
  if (dlvIndex < dlvPos) dlvPos = dlvIndex;
  else if (dlvIndex >= dlvPos + DLV_THUMB_VISIBLE) dlvPos = dlvIndex - DLV_THUMB_VISIBLE + 1;

  const w = items[0].getBoundingClientRect().width;
  const gap = parseFloat(getComputedStyle(track).gap) || 8;
  track.style.transform = `translateX(-${dlvPos * (w + gap)}px)`;

  updateDeliveryArrows();
}

function updateDeliveryArrows() {
  const prev = document.getElementById("deliveryThumbPrev");
  const next = document.getElementById("deliveryThumbNext");
  if (!prev || !next) return;
  prev.disabled = dlvIndex <= 0;
  next.disabled = dlvIndex >= dlvImages.length - 1;
}

const deliveryModalEl = document.getElementById("deliveryModal");
if (deliveryModalEl) {
  deliveryModalEl.addEventListener("click", function (e) {
    const prev = e.target.closest("#deliveryThumbPrev");
    const next = e.target.closest("#deliveryThumbNext");
    const thumb = e.target.closest(".dlv-thumb-item");

    if (prev) { e.stopPropagation(); setDeliveryImage(dlvIndex - 1); return; }
    if (next) { e.stopPropagation(); setDeliveryImage(dlvIndex + 1); return; }
    if (thumb) { e.stopPropagation(); setDeliveryImage(Number(thumb.dataset.index)); }
  });
}

  
  /* --------------------------------------------
     OPEN DELIVERY MODAL
  -----------------------------------------------*/
  function openPopup(e) {
    e.stopPropagation();

    const card = e.target.closest(".delivery-card");
    if (!card) return;

    const storeMoneyFormat = document.querySelector('input#storeMoneyFormat').value;
    modalSourceCard = card;

    const modal = document.getElementById("deliveryModal");
    if (!modal) return;

    const title = card.dataset.variantName || "";
    const price = card.dataset.variantPrice || "";
    const descKey = card.dataset.desc || "";
    const detailImg = card.dataset.image || "";

    const modalTitle = modal.querySelector(".modal-title");
    const modalPrice = modal.querySelector(".modal-price");
    const modalImage = modal.querySelector(".modal-image");
    const modalRrp = modal.querySelector(".modal-rrp");
    const modalDetails = modal.querySelector(".modal-details");
    const productViewBtn = modal.querySelector(".modal-product-view");
    const productUrl = card.dataset.productUrl || "#";

    const cleanTitle = title.replace(/\s*\([^)]*\)/g, '').trim();

modalTitle.textContent = cleanTitle;
    
/* Expert Installation → zone map first, then the normal image */const t = title.toLowerCase();
const showZoneMap =
  t.includes("expert installation") || t.includes("care+ installation");

renderDeliveryThumbs(
  showZoneMap ? [ZONE_MAP_IMG, detailImg] : [detailImg]
);

    const isFree = !price || price === '0';
    if(isFree){
  modalPrice.innerHTML = 'FREE';

  if(modalRrp){
    modalRrp.style.display = 'none';
  }

} else {

  const newPrice = card.dataset.variantPrice;

  const vatLabel = document.createElement('span');
  vatLabel.className = 'vat-text' ;
  vatLabel.innerText = ' (Inc. VAT)';

  modalPrice.innerHTML = Shopify.formatMoney(newPrice, storeMoneyFormat);
  modalPrice.appendChild(vatLabel);

  /* RRP ONLY FOR ULTIMA PRODUCT */
    //   const titleLower = title.toLowerCase();

    // if (
    //   modalRrp &&
    //   (
    //     titleLower.includes('expert installation') ||
    //     titleLower.includes('care+')
    //   )
    // ) {

    //     let rrpText = '';

    //     // if (titleLower.includes('expert installation')) {
    //     //   rrpText = 'RRP: £119.95';
    //     // }

    //     if (titleLower.includes('care+')) {
    //       rrpText = 'RRP: £199.50';
    //     }

    //     modalRrp.innerHTML = `<span>${rrpText}</span>`;
    //     modalRrp.style.display = 'block';

    //   } else if(modalRrp) {

    //     modalRrp.style.display = 'none';
    //   }
  if (modalRrp) {
    const actualPrice = Number(card.dataset.variantPrice || 0);
    const comparePrice = Number(card.dataset.variantComparePrice || 0);

    if (comparePrice > actualPrice && actualPrice > 0) {
      modalRrp.innerHTML =
        'RRP: <span style="text-decoration: line-through;">' +
        Shopify.formatMoney(comparePrice, storeMoneyFormat) +
        '</span>';

      modalRrp.style.display = 'block';
    } else {
      modalRrp.innerHTML = '';
      modalRrp.style.display = 'none';
    }
  }
}

    modalDetails.innerHTML = "";
    if (detailImg) {
      modalImage.style.display = "block";
    }

    /* ---------- DETAILS + IMAGE OVERRIDE ---------- */
    const sourceDetail = card.querySelector('.delivery-details-info .metafield-rich_text_field').innerHTML;

    if (sourceDetail) {

  let updatedDetail = sourceDetail;

  /* ONLY FOR ULTIMA PRODUCT */
  const isUltimaProduct = window.location.pathname.includes(
    'yo-yo-desk-ultima-dual-motor-height-adjustable-standing-desk-copy'
  );

  const titleLower = title.toLowerCase();

  /* TEMP STATIC 50% OFF */
  if (
    isUltimaProduct &&
    (
      titleLower.includes('expert installation') ||
      titleLower.includes('care+ installation')
    )
  ) {

    updatedDetail = updatedDetail.replace(
      '<ul>',
      '<ul><li><strong">50% OFF</strong></li>'
    );
  }

  const info = document.createElement('div');
  info.className = 'modal-details-info';
  info.innerHTML = updatedDetail;

  modalDetails.appendChild(info);
}

  /* BUTTON ROW WRAPPER */
let btnRow = modal.querySelector('.modal-btn-row');

if (!btnRow) {

  btnRow = document.createElement('div');
  btnRow.className = 'modal-btn-row';

  const selectBtn = modal.querySelector('.modal-select');
  const productBtn = modal.querySelector('.modal-product-view');

  if (selectBtn) btnRow.appendChild(selectBtn);
  if (productBtn) btnRow.appendChild(productBtn);

  modal.querySelector('.pop-info').appendChild(btnRow);
}
    modal.classList.add("active");
    // Show button only for installation products
if (
  title.toLowerCase().includes("expert installation")
) {
  productViewBtn.style.display = "inline-block";
  productViewBtn.href = "https://yo-yodesk.co.uk/products/installation-service-5";
}
else if (
  title.toLowerCase().includes("care+ installation")
) {
  productViewBtn.style.display = "inline-block";
  productViewBtn.href = "https://yo-yodesk.co.uk/products/care-10-year-install-warranty";
}else {
  productViewBtn.style.display = "none";
}
    document.body.style.overflow = "hidden";
  }

  /* --------------------------------------------
     CLOSE DELIVERY MODAL
  -----------------------------------------------*/
  function closePopup() {
    const modal = document.getElementById("deliveryModal");
    if (!modal) return;

    modal.classList.remove("active");
    document.body.style.overflow = "";
    modalSourceCard = null;
  }

  /* --------------------------------------------
     CLICK HANDLERS
  -----------------------------------------------*/
  document.querySelectorAll(".delivery-option-button").forEach((infoBtn)=>{
    infoBtn.addEventListener("click", function (e) {
        openPopup(e);
        return;
    });
  });
    /* "See Zone Map" text opens the same View Details popup */
document.querySelectorAll(".see-zone-map-link").forEach((link) => {
  const open = (e) => {
    e.preventDefault();
    openPopup(e); // already does stopPropagation, so the card isn't selected/deselected
  };

  link.addEventListener("click", open);
  link.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") open(e);
  });
});


  document.querySelectorAll(".close-modal-btn, #deliveryModal").forEach((closeBtn) => {
      closeBtn.addEventListener("click", function (e) {
          if (e.target.classList.contains("close-modal-btn")) {
              closePopup();
              return;
          }
          if (e.target.id === "deliveryModal") {
              closePopup();
              return;
          }
      });
  });


  document.querySelectorAll("#deliveryModal .modal-select").forEach((selectBtn) => {
      selectBtn.addEventListener("click", async function (e) {
          /* Disabled (below £15000 order-value) card cannot be selected from the modal either */
          if (modalSourceCard && modalSourceCard.classList.contains("disabled")) {
              closePopup();
              return;
          }
          if (modalSourceCard && !modalSourceCard.classList.contains("selected")) {
              await selectDeliveryCard(modalSourceCard);
          }
          closePopup();
          return;
      });
  });

  document.querySelectorAll(".delivery-card").forEach((card) => {
      card.addEventListener("click", async function (e) {
          /* Disabled (below £15000 order-value) card cannot be clicked/selected */
          if (card.classList.contains("disabled")) {
              return;
          }

          if (card.classList.contains("selected")) {
              return;
          }

          await selectDeliveryCard(card);
      });
  });



  // async function selectDeliveryCard(card, pageload = false) {

  //   if (card.classList.contains("selected") && !pageload) return;

  //   const selectedId = card.dataset.id;
  //   const headerTitle = document.querySelector(".Delivery_title");

  //     document.querySelectorAll(".delivery-card").forEach(c =>
  //       c.classList.remove("selected")
  //     );
  //     card.classList.add("selected");
  //     document.querySelector(".delivery-grid")?.classList.remove("delivery-error");

  //     const error = document.querySelector(".delivery-validation-error");
  //     if (error) {
  //         error.hidden = true;
  //     }

  //   const priceElement = card.querySelector(".delivery-price");
  //   const deliveryPrice = priceElement?.dataset.price;
  //   if (deliveryPrice !== undefined) {
  //     updateTotalPrice(deliveryPrice);
  //   }
  //   updateAccessoryCardData();

  //   const selectedDesc = card.querySelector(".desc")?.textContent || "";
  //   if (headerTitle) {
  //     if(headerTitle.classList.contains('accessory_delivery_title')){
  //       headerTitle.textContent = "Delivery Options: " + selectedDesc;
  //     } else {
  //       headerTitle.textContent = "Delivery:" + selectedDesc;
  //     }
  //   }

  //   // 🔥 NEW FIX STARTS HERE 🔥

  //   const allBoldRadios = document.querySelectorAll(
  //     '.bold_option_set input[type="radio"]'
  //   );

  //   allBoldRadios.forEach((radio) => {
  //     if (radio.checked) {
  //       radio.checked = false;
  //       radio.dispatchEvent(new Event("change", { bubbles: true }));
  //     }
  //   });

  //   allBoldRadios.forEach((radio) => {
  //     if (radio.dataset.productHandle === selectedId) {
  //       radio.checked = true;
  //       radio.dispatchEvent(new Event("change", { bubbles: true }));
  //     }
  //   });

  // }

  /* --------------------------------------------
     UPDATE TOTAL PRICE
  -----------------------------------------------*/
  function updateTotalPrice(deliveryPrice) {
    const totalPrices = document.querySelectorAll(".totalprice");
    const basePriceInput = document.getElementById("base-vaiant-price");
    const deliveryTotalInput = document.getElementById("deliveryoptions_price");

    if (!basePriceInput || !deliveryTotalInput) return;

    let prevDelivery = Number(deliveryTotalInput.value || 0);
    let baseTotal = Number(basePriceInput.value || 0);

    let updatedTotalPrice = parseFloat(basePriceInput.getAttribute("data-inc-base-price")) / 100;

    let updatedExcTotalPrice;

    baseTotal -= prevDelivery * 100;
    baseTotal += Number(deliveryPrice) * 100;

    updatedTotalPrice -= prevDelivery;
    updatedTotalPrice += Number(deliveryPrice);

    updatedExcTotalPrice = parseFloat((updatedTotalPrice / 1.2).toFixed(2));

    basePriceInput.setAttribute("data-inc-base-price", updatedTotalPrice * 100);
    basePriceInput.value = baseTotal;
    // basePriceInput.value = baseTotal * 100;
    deliveryTotalInput.value = deliveryPrice;

    totalPrices.forEach(price => {
      price.textContent = `£${updatedTotalPrice.toFixed(2)}`;
    });
    document.querySelectorAll('#main-price-incl-vat .money').forEach(function(el, index) {
        el.innerHTML = `£${updatedTotalPrice.toFixed(2)}`;
    });

    document.querySelectorAll('.additional-prices .ex-vat-wrapper .money').forEach(function(el, index) {
        el.innerHTML = `£${updatedExcTotalPrice.toFixed(2)}`;
    });
  }

  /* --------------------------------------------
     SELECT DELIVERY CARD
  -----------------------------------------------*/
async function selectDeliveryCard(card, pageload = false) {

  if (card.classList.contains("selected") && !pageload) {
    return;
  }

  const selectedId = card.dataset.id;
  const headerTitle = document.querySelector(".Delivery_title");

    document.querySelectorAll(".delivery-card").forEach(c =>
      c.classList.remove("selected")
    );
    card.classList.add("selected");
    document.querySelector(".delivery-grid")?.classList.remove("delivery-error");

    const error = document.querySelector(".delivery-validation-error");
    if (error) {
        error.hidden = true;
    }

  const priceElement = card.querySelector(".delivery-price");
  const deliveryPrice = priceElement?.dataset.price;

  document.getElementById('delivery_card_variant_ids').value = card.dataset.variantId;
  document.getElementById('delivery_card_variant_prices').value = card.dataset.variantPrice;
  document.getElementById('delivery_card_variant_names').value = card.dataset.variantName;
  document.getElementById('delivery_card_product_ids').value = card.dataset.productId;

  await updateAccessoryCardData();
  
  if (deliveryPrice !== undefined) {
    updateTotalPrice(deliveryPrice);
  }
  // updateAccessoryCardData();

  const selectedDesc = card.querySelector(".desc")?.textContent || "";
  if (headerTitle) {
    if(headerTitle.classList.contains('accessory_delivery_title')){
      headerTitle.textContent = "Delivery Options: " + selectedDesc;
    } else {
      headerTitle.textContent = "Delivery:" + selectedDesc;
    }
  }

  const allBoldRadios = document.querySelectorAll(
    '.bold_option_set input[type="radio"]'
  );

  allBoldRadios.forEach((radio) => {
    if (radio.checked) {
      radio.checked = false;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  allBoldRadios.forEach((radio) => {
    if (radio.dataset.productHandle === selectedId) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

    


}
function refreshDeliveryHeader() {
  const selectedCard = document.querySelector(".delivery-card.selected");
  if (!selectedCard) return;

  selectDeliveryCard(selectedCard, true);
}

document.querySelectorAll(
  'input[name="Desk Top Colour"], input[name="Desk Top Size(cm)"]'
).forEach(input => {
  input.addEventListener("change", () => {
    refreshDeliveryHeader();
  });
});



  function normalizeBoldDeliveryRadios() {
  document.querySelectorAll(
    '.bold_option_set input[type="radio"]'
  ).forEach((radio) => {
    radio.name = 'delivery_option_group';
  });
}


function observeBoldRadios() {
  const boldRoot = document.querySelector('.bold_options');
  if (!boldRoot) return;

  const observer = new MutationObserver(() => {
    normalizeBoldDeliveryRadios();
  });

  observer.observe(boldRoot, {
    childList: true,
    subtree: true
  });

  // Run once immediately
  normalizeBoldDeliveryRadios();
}


 /* --------------------------------------------
     DEFAULT HEADER ON LOAD
  -----------------------------------------------*/
  const defaultCard = document.querySelector(".delivery-card.selected");
  const headerTitle = document.querySelector(".Delivery_title");

  if (defaultCard && headerTitle) {
    const defaultDesc = defaultCard.querySelector(".desc")?.textContent || "";
    if(headerTitle.classList.contains('accessory_delivery_title')){
      headerTitle.textContent = "Delivery Options: " + defaultDesc;
    } else {
      headerTitle.textContent = "Delivery: " + defaultDesc;
    }
  }

  /* --------------------------------------------
     ORDER VALUE (£15000+) DELIVERY CARD
     - Card whose title contains "Order Value" and "15000"
     - Never auto-selected on page load
     - Disabled (greyed out / unclickable) while order
       subtotal (excluding current delivery cost, INCLUDING
       quantity and any active accessories/add-ons) is below
       £15000
     - The MOMENT the subtotal crosses INTO £15000+ (i.e. it was
       below threshold and is now at/above it), it is auto-selected
     - While it's already eligible (still £15000+) it stays enabled
       but is NOT force-reselected again — if the user manually
       switches to a different delivery card while still eligible,
       that choice is respected and left alone
     - If subtotal drops back below £15000 — whether from a variant
       change, an accessory being removed, OR the quantity being
       reduced — it is automatically disabled AND deselected
       (falls back to free delivery), and the "selected" class is
       ALWAYS stripped from it even if no free card is available
       to fall back to
  -----------------------------------------------*/
  const ORDER_VALUE_THRESHOLD = 15000;

  // Tracks the eligibility state from the previous check, so we only
  // auto-select on the transition into eligibility, never on every
  // recheck while it's already eligible.
  let orderValueEligible = false;

  function getOrderValueCard() {
    return [...document.querySelectorAll('.delivery-card')].find(card => {
      const name = (card.dataset.variantName || card.dataset.title || '').toLowerCase();
      return name.includes('order value') && name.includes('15000');
    });
  }

  // Reads the live quantity from the product form's quantity input.
  // Falls back to 1 if it can't be found or isn't a valid positive number.
  function getCurrentQuantity() {
    const qtyInput = document.querySelector(
      'quantity-input input[name="quantity"], input.quantity__input[name="quantity"], input[name="quantity"]'
    );
    const qty = parseInt(qtyInput?.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  // Product/order subtotal, excluding whatever delivery option is currently
  // applied - so toggling delivery selection itself never flips the threshold.
  // data-inc-base-price already includes any active accessories/add-ons
  // (updateTotalPrice() folds those into it), so we only need to strip out
  // the current delivery cost and then scale by quantity.
  function getProductOnlyTotal() {
    const basePriceInput = document.getElementById('base-vaiant-price');
    const deliveryPriceInput = document.getElementById('deliveryoptions_price');
    if (!basePriceInput) return 0;

    const incBase = parseFloat(basePriceInput.getAttribute('data-inc-base-price')) || 0;
    const currentDeliveryPrice = Number(deliveryPriceInput?.value || 0);

    const unitTotal = (incBase / 100) - currentDeliveryPrice;
    const quantity = getCurrentQuantity();

    return unitTotal * quantity;
  }

  function selectFallbackFreeCard() {
    const orderValueCard = getOrderValueCard();

    // Always drop the selected state first. The £15000+ card must never
    // stay visually "selected" once it becomes disabled, even if no
    // visible free card exists to fall back to (e.g. it's mid-toggle
    // during the 4-week lead time swap).
    if (orderValueCard) {
      orderValueCard.classList.remove('selected');
    }

    const freeCard = [...document.querySelectorAll('.delivery-card')].find(card => {
      if (card === orderValueCard) return false;
      if (window.getComputedStyle(card).display === 'none') return false;
      const price = Number(card.querySelector('.delivery-price')?.dataset.price || 0);
      return price === 0;
    });

    if (freeCard) {
      selectDeliveryCard(freeCard, true);
    } else {
      // No visible free card to fall back to - clear selection entirely
      // and zero out the delivery line so totals stay correct.
      document.querySelectorAll('.delivery-card').forEach(c => c.classList.remove('selected'));
      updateTotalPrice(0);
    }
  }

  /**
   * @param {boolean} isInitial - true only for the very first check on
   * page load. On that first check we still correctly mark the card as
   * enabled/disabled based on the current total, but we never force a
   * selection - per the requirement that it must never be pre-selected
   * on load, even if the default variants already total £15000+.
   */
  function updateOrderValueDeliveryCard(isInitial = false) {
    const card = getOrderValueCard();
    if (!card) return;

    const meetsThreshold = getProductOnlyTotal() >= ORDER_VALUE_THRESHOLD;

    if (meetsThreshold) {
      card.classList.remove('disabled');

      // Auto-select ONLY on the transition into eligibility. If it was
      // already eligible on the previous check, leave the current
      // selection (whatever the user picked) alone.
      if (!isInitial && !orderValueEligible && !card.classList.contains('selected')) {
        selectDeliveryCard(card, true);
      }
    } else {
      card.classList.add('disabled');
      if (card.classList.contains('selected')) {
        selectFallbackFreeCard();
      } else {
        // Belt-and-braces: even if some other path selected it without
        // going through selectDeliveryCard, make sure it's never left
        // both disabled AND selected.
        card.classList.remove('selected');
      }
    }

    orderValueEligible = meetsThreshold;
  }

  // Expose so other listeners further down the file (e.g. the lead-time
  // toggler) can trigger a recheck without duplicating this logic.
  window.updateOrderValueDeliveryCard = updateOrderValueDeliveryCard;

  // Watch the price input that updateTotalPrice() writes to - catches
  // quantity changes, variant changes, accessory changes, delivery
  // switches, anything that moves the order total.
  (function watchOrderValueTotal() {
    const basePriceInput = document.getElementById('base-vaiant-price');
    if (!basePriceInput) return;

    let debounceTimer;
    const debouncedUpdate = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => updateOrderValueDeliveryCard(), 150);
    };

    const observer = new MutationObserver(debouncedUpdate);
    observer.observe(basePriceInput, {
      attributes: true,
      attributeFilter: ['data-inc-base-price', 'value']
    });
  })();

  // Extra safety net: some swatch/variant changes (colour, size, type,
  // fabric, etc.) recalculate price via AJAX and may not always update
  // the exact attribute the observer above watches in the same tick.
  // Re-check shortly after ANY change/click inside the product form so
  // the £15000+ card's enabled/selected state never gets stuck out of
  // sync with the real order total.
  (function watchFormForPriceChanges() {
    const form = document.querySelector('form.js-product-form.form[action*="/cart/add"]');
    if (!form) return;

    let formDebounce;
    const debouncedFormUpdate = () => {
      clearTimeout(formDebounce);
      formDebounce = setTimeout(() => updateOrderValueDeliveryCard(), 400);
    };

    form.addEventListener('change', debouncedFormUpdate);
    form.addEventListener('click', debouncedFormUpdate);
  })();

  // Dedicated quantity watcher. The quantity stepper buttons already
  // trigger the form change/click listener above, but typing directly
  // into the quantity field only fires "input" (not "change") until the
  // field loses focus - and we want the £15000+ card to react instantly
  // as the number changes, not just on blur.
  (function watchQuantityForOrderValue() {
    const qtyInput = document.querySelector(
      'quantity-input input[name="quantity"], input.quantity__input[name="quantity"], input[name="quantity"]'
    );
    if (!qtyInput) return;

    let qtyDebounce;
    const debouncedQtyUpdate = () => {
      clearTimeout(qtyDebounce);
      qtyDebounce = setTimeout(() => updateOrderValueDeliveryCard(), 150);
    };

    qtyInput.addEventListener('input', debouncedQtyUpdate);
    qtyInput.addEventListener('change', debouncedQtyUpdate);

    // Quantity +/- buttons: some themes update the input value via JS
    // without firing a native "input" event, so also listen directly
    // on the stepper buttons as a safety net.
    const qtyWrapper = qtyInput.closest('quantity-input');
    if (qtyWrapper) {
      qtyWrapper.querySelectorAll('button[name="minus"], button[name="plus"]').forEach((btn) => {
        btn.addEventListener('click', debouncedQtyUpdate);
      });
    }
  })();

  // Initialize selected delivery card on page load
setTimeout(() => {

  document.querySelectorAll(".delivery-card").forEach(card => {
    card.classList.remove("selected");
  });

  const orderValueCard = getOrderValueCard();

  // Find first VISIBLE FREE delivery card (excluding the £15000+ card,
  // which must never be auto-selected purely for being free)
  const freeCard = Array.from(document.querySelectorAll(".delivery-card"))
  //   .find(card => {

  //     if (card === orderValueCard) {
  //       return false;
  //     }

  //     if (window.getComputedStyle(card).display === "none") {
  //       return false;
  //     }

  //     const price = Number(
  //       card.querySelector(".delivery-price")?.dataset.price || 0
  //     );

  //     return price === 0;
  //   });

  // if (freeCard) {
  //   selectDeliveryCard(freeCard, true);
  // }

    const firstVisibleCard = Array.from(document.querySelectorAll(".delivery-card")).find(card => {
    if (card === orderValueCard) return false;
    const style = window.getComputedStyle(card);
    return (style.display !== "none" && style.visibility !== "hidden" && !card.classList.contains("disabled"));
  });

  if (firstVisibleCard) {
    const rawPrice = firstVisibleCard
      .querySelector(".delivery-price")?.dataset.price;
    const price = rawPrice !== undefined ? Number(rawPrice) : NaN;
    if (price === 0) {
      selectDeliveryCard(firstVisibleCard, true);
    } else {
    }

  }

  // Set correct initial disabled/enabled state for the £15000+ card
  // based on the current order subtotal, WITHOUT force-selecting it.
  updateOrderValueDeliveryCard(true);

}, 300);

});


  
document.addEventListener('DOMContentLoaded', function () {
  const sizeRadios = document.querySelectorAll(
    'input[name="Desk Top Size(cm)"]'
  );
  const colorRadios = document.querySelectorAll(
    'input[name="Desk Top Colour"]'
  );

  const deliveryTitle = document.querySelector('.Delivery_title');

  const leadTimeText = '4 week lead time';

  const restrictedSize = '160x80';
  const restrictedColors = ['Maple', 'Dark Grey', 'Black', 'Golden Maple', 'Slate Dark Grey', 'Midnight Black'];

  function updateDeliveryTitle() {
    const selectedSize = document.querySelector(
      'input[name="Desk Top Size(cm)"]:checked'
    )?.value;

    const selectedColor = document.querySelector(
      'input[name="Desk Top Colour"]:checked'
    )?.value;

    if (
      selectedSize === restrictedSize &&
      restrictedColors.includes(selectedColor)
    ) {
      deliveryTitle.textContent = leadTimeText;
    }
  }

  sizeRadios.forEach(radio => {
    radio.addEventListener('change', updateDeliveryTitle);
  });

  colorRadios.forEach(radio => {
    radio.addEventListener('change', updateDeliveryTitle);
  });

  // Run once on page load
  updateDeliveryTitle();
  updateAccessoryCardData();
});
 


async function updateAccessoryCardData() {
  const accessoriesSection = document.getElementById("dynamic-accessories-section");
  const deliveriesSection = document.getElementById("dynamic-delivery-options-section");

  // ✅ return ONLY if both are missing
  if (!accessoriesSection && !deliveriesSection) return;

  const activeAccessoryCards = accessoriesSection?.querySelectorAll(".accessory-card.active") || [];
  const activeDeliveryCards = deliveriesSection?.querySelectorAll(".delivery-card.selected") || [];

  const getVal = (id) => document.getElementById(id);

  const accessoryVariantInput = getVal("accessory_card_variant_ids");
  const accessoryProductInput = getVal("accessory_card_product_ids");
  const accessoryPriceInput = getVal("accessory_card_variant_prices");
  const accessoryNameInput = getVal("accessory_card_variant_names");

  const deliveryVariantInput = getVal("delivery_card_variant_ids");
  const deliveryProductInput = getVal("delivery_card_product_ids");
  const deliveryPriceInput = getVal("delivery_card_variant_prices");
  const deliveryNameInput = getVal("delivery_card_variant_names");

  let variantIds = [], productIds = [], prices = [], names = [];

  let accessoryData = { v: [], p: [], pr: [], n: [] };
  let deliveryData = { v: [], p: [], pr: [], n: [] };

  const seen = new Set();

  const process = (cards, target) => {
      cards.forEach(card => {
          const { variantId, productId, variantPrice: price, variantName: name } = card.dataset;

          if (variantId && productId && price && name && !seen.has(variantId)) {
              seen.add(variantId);

              variantIds.push(variantId);
              productIds.push(productId);
              prices.push(price);
              names.push(name);

              target.v.push(variantId);
              target.p.push(productId);
              target.pr.push(price);
              target.n.push(name);
          }
      });
  };

  process(activeAccessoryCards, accessoryData);
  process(activeDeliveryCards, deliveryData);

  // ✅ assign values safely
  if (accessoryVariantInput) accessoryVariantInput.value = accessoryData.v.join(",");
  if (accessoryProductInput) accessoryProductInput.value = accessoryData.p.join(",");
  if (accessoryPriceInput) accessoryPriceInput.value = accessoryData.pr.join(",");
  if (accessoryNameInput) accessoryNameInput.value = accessoryData.n.join(",");

  if (deliveryVariantInput) deliveryVariantInput.value = deliveryData.v.join(",");
  if (deliveryProductInput) deliveryProductInput.value = deliveryData.p.join(",");
  if (deliveryPriceInput) deliveryPriceInput.value = deliveryData.pr.join(",");
  if (deliveryNameInput) deliveryNameInput.value = deliveryData.n.join(",");

  const form = document.querySelector('form.js-product-form.form[action*="/cart/add"]');
  if (!form) return;

  let container = form.querySelector(".form-accessories-container");
  if (!container) {
      container = Object.assign(document.createElement("div"), {
          id: "form_accessories_container",
          className: "form-accessories-container"
      });
      form.appendChild(container);
  }

  const getInput = (name) => {
      let el = container.querySelector(`input[name="${name}"]`);
      if (!el) {
          el = Object.assign(document.createElement("input"), {
              type: "hidden",
              name
          });
          container.appendChild(el);
      }
      return el;
  };

  const groupInput = getInput("properties[_accessoryGroupId]");
  const variantInputForm = getInput("properties[_accessoryVariantIds]");
  const productInputForm = getInput("properties[_accessoryProductIds]");
  const priceInputForm = getInput("properties[_accessoryVariantPrices]");
  const nameInputForm = getInput("properties[_accessoryVariantNames]");

  if (!variantIds.length) {
      [groupInput, variantInputForm, productInputForm, priceInputForm, nameInputForm]
          .forEach(i => i.value = "");
      return;
  }

  if (!groupInput.value) {
      groupInput.value = await generateUniqueAccessoryGroupId();
  } else {
      const isUsed = await validateAccessoryGroupId(groupInput.value);
      if(isUsed) {
          groupInput.value = await generateUniqueAccessoryGroupId();
      }
  }

  variantInputForm.value = variantIds.join(",");
  productInputForm.value = productIds.join(",");
  priceInputForm.value = prices.join(",");
  nameInputForm.value = names.join(",");
}

async function generateUniqueAccessoryGroupId() {
  const generate = () => Math.floor(10000000000 + Math.random() * 90000000000).toString();

  let newId;
  let exists = true;

  do {
      newId = generate();
      exists = await validateAccessoryGroupId(newId);
  } while (exists);

  return newId;
}

async function validateAccessoryGroupId(id) {
  const res = await fetch("/cart.js");
  const cart = await res.json();

  return cart.items.some((item) => {
      return String(item.properties?._accessoryGroupId) === String(id);
  });
}


document.addEventListener("DOMContentLoaded", function () {

  // console.log("🔎 VAT label observer started");

  function updateVatLabel() {
    const vatLabel = document.querySelector('.price-container .label');

    if (vatLabel && vatLabel.textContent.trim() === "Incl. VAT") {
      // console.log("✅ Found Incl. VAT — updating...");
      vatLabel.textContent = "Inc. VAT";
    }
  }

  // Run once immediately
  updateVatLabel();

  // Watch for dynamic changes
  const observer = new MutationObserver(function () {
    updateVatLabel();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


// new js for 4week lead
// ======================================================
// TEMP 4 WEEK DELIVERY TOGGLER
// ONLY FOR EXEC 2 COPY PRODUCT
// ======================================================

document.addEventListener('DOMContentLoaded', function () {

  

  // ----------------------------------------------------
  // RESTRICTED COMBINATIONS
  // ----------------------------------------------------

  const restrictedColours = [
    'Black',
    'Dark Grey',
    'Maple',
    'Golden Maple',
    'Slate Dark Grey',
    'Midnight Black'
  ];

  const restrictedSizes = [
    '160x80',
    '180x80',
    '160x80cm',
    '180x80cm',
    '160x80 + 60x80',
    '180x80 + 60x80',
    '160x80cm + 60x80',
    '180x80cm + 60x80'
  ];

  // ----------------------------------------------------
  // CHECK RESTRICTED STATE
  // ----------------------------------------------------

  function isRestrictedCombination() {

    const selectedColour =
      document.querySelector(
        'input[name="Desk Top Colour"]:checked'
      )?.value || '';

    const selectedSize =
      document.querySelector(
        'input[name="Desk Top Size(cm)"]:checked'
      )?.value || '';

    const desktopRestricted =
      restrictedColours.includes(selectedColour) &&
      restrictedSizes.includes(selectedSize);

    // Accessories that require 4 week lead time
    const leadTimeAccessories = [
      'Deluxe Ply Edge',
      '2 X  Deluxe Ply Edge',
      'Scallop Top',
      '2 X Scallop Top',
      '2 X Wave Desktop',
      'Wave Desktop'
    ];

    const customTopAccessoryActive = [
      ...document.querySelectorAll(
        '.accessory-slider[data-tab="custom_top_options"] .accessory-card.active'
      )
    ].some(card =>
      leadTimeAccessories.includes(
        (card.dataset.card || '').trim()
      )
    );

    return desktopRestricted || customTopAccessoryActive;
  }

  function updateLeadTimeHeader() {

  const deliveryTitle =
    document.querySelector('.Delivery_title');

  

  if (!deliveryTitle) return;

  const selectedColour =
    document.querySelector(
      'input[name="Desk Top Colour"]:checked'
    )?.value || '';

  const selectedSize =
    document.querySelector(
      'input[name="Desk Top Size(cm)"]:checked'
    )?.value || '';

  const colourLabel = document.querySelector(
    '[data-name="Desk Top Colour"] .selected-value'
  );

  const restricted =
    isRestrictedCombination();

  if (restricted) {

  if (colourLabel) {
  colourLabel.innerHTML =
  `${selectedColour}<span class="leadtime-note">&nbsp;(4 Week Lead Time on ${selectedSize} Combination)</span>`;
}

    const leadTimeAccessories = [
      'Deluxe Ply Edge',
      '2 X  Deluxe Ply Edge',
      'Scallop Top',
      '2 X Scallop Top',
      '2 X Wave Desktop',
      'Wave Desktop'
    ];

    const activeCustomTop = [
      ...document.querySelectorAll(
        '.accessory-slider[data-tab="custom_top_options"] .accessory-card.active'
      )
    ].find(card =>
      leadTimeAccessories.includes(
        (card.dataset.card || '').trim()
      )
    );

    if (activeCustomTop) {

      const accessoryName =
        activeCustomTop.dataset.card || '';

       deliveryTitle.innerHTML =
        `Delivery: <span class="delivery-leadtime">4 Week Lead Time on ${accessoryName} Combination</span>`;

    } else {

     deliveryTitle.innerHTML =
      `Delivery: <span class="delivery-leadtime">4 Week Lead Time on ${selectedSize} + ${selectedColour} Combination</span>`;


    }

    

  } else {

    if (colourLabel) {
      colourLabel.textContent = selectedColour;
    }

  }
}

  // ----------------------------------------------------
  // TOGGLE DELIVERY CARDS
  // ----------------------------------------------------

  function toggleLeadTimeCards() {

  // Modesty Panel + Clearance PDP → show all delivery options
if (
  window.location.pathname.includes('/products/modesty-panel') ||
  window.location.pathname.includes('/products/side-privacy-screen') ||
  window.location.pathname.includes('/products/front-privacy-screen') ||
  window.location.pathname.includes('/products/dividing-privacy-screen') ||
  window.location.pathname.includes('/products/wellness-2-plus') ||
  document.body.classList.contains('template-clearance_page')
) {
  document.querySelectorAll('.delivery-card').forEach(card => {
    card.style.removeProperty('display');
  });

  return;
}

  const restricted = isRestrictedCombination();

  const deliveryCards =
    document.querySelectorAll('.delivery-card');

    let firstVisibleCard = null;

    deliveryCards.forEach((card) => {

      const variantName =
        (
          card.dataset.variantName ||
          card.dataset.title ||
          ''
        ).toLowerCase();

      const isLeadTimeCard =
        variantName.includes('(4 week lead time)') ||
        variantName.includes('(4 week)');

      // ----------------------------------------------
      // SHOW ONLY 4 WEEK CARDS
      // ----------------------------------------------

      if (restricted) {

        if (isLeadTimeCard) {

          card.style.removeProperty('display');

          if (!firstVisibleCard) {
            firstVisibleCard = card;
          }

        } else {

          card.style.setProperty(
            'display',
            'none',
            'important'
          );
        }

      }

      // ----------------------------------------------
      // SHOW ONLY REGULAR CARDS
      // ----------------------------------------------

      else {

        if (isLeadTimeCard) {

          card.style.setProperty(
            'display',
            'none',
            'important'
          );

        } else {

          card.style.removeProperty('display');

          if (!firstVisibleCard) {
            firstVisibleCard = card;
          }
        }
      }
    });

    // ------------------------------------------------
    // AUTO SELECT FIRST VISIBLE CARD
    // ------------------------------------------------

    // ------------------------------------------------
// AUTO SELECT FREE DELIVERY ONLY -- BUT ONLY IF THE
// CURRENTLY SELECTED CARD IS NO LONGER VALID (i.e. it
// just got hidden by the restricted/unrestricted toggle
// above). If the user's current selection is still
// visible, leave it alone -- this is what previously
// caused any manually-picked delivery option (paid or
// free) to snap back to the free card on every unrelated
// re-render (slider prev/next, resize, tab switch, etc).
// ------------------------------------------------

const currentlySelected = document.querySelector('.delivery-card.selected');
const currentlySelectedStillVisible =
  currentlySelected &&
  window.getComputedStyle(currentlySelected).display !== 'none';

  if (!currentlySelectedStillVisible) {

  console.log(
    "🔎 [Delivery Debug] Current selected card is hidden or missing."
  );

  console.log(
    "🔎 [Delivery Debug] Restricted condition:",
    restricted
  );

  console.log(
    "🔎 [Delivery Debug] Expected card:",
    restricted
      ? "First visible 4-week delivery card"
      : "First visible regular delivery card"
  );

  // Find the £15,000 order-value card.
  const orderValueCardEl = [
    ...document.querySelectorAll(".delivery-card")
  ].find((card) => {

    const name = (
      card.dataset.variantName ||
      card.dataset.title ||
      ""
    ).toLowerCase();

    const isOrderValue =
      name.includes("order value") &&
      name.includes("15000");

    if (isOrderValue) {
      console.log(
        "🚫 [Delivery Debug] Excluding order-value card:",
        name
      );
    }

    return isOrderValue;
  });

  // Find the first eligible card matching the condition.
  const firstValidVisibleCard = [
    ...document.querySelectorAll(".delivery-card")
  ].find((card) => {

    const style = window.getComputedStyle(card);

    const name = (
      card.dataset.variantName ||
      card.dataset.title ||
      ""
    ).toLowerCase();

    const isVisible =
      style.display !== "none" &&
      style.visibility !== "hidden";

    const isLeadTimeCard =
      name.includes("(4 week lead time)") ||
      name.includes("(4 week)");

    const isDisabled =
      card.classList.contains("disabled");

    const isOrderValueCard =
      card === orderValueCardEl;

    // Restricted = 4-week card.
    // Not restricted = regular card.
    const matchesCondition = restricted
      ? isLeadTimeCard
      : !isLeadTimeCard;

    console.log("📦 [Delivery Debug] Checking card:", {
      name: name,
      visible: isVisible,
      isFourWeekCard: isLeadTimeCard,
      disabled: isDisabled,
      isOrderValueCard: isOrderValueCard,
      matchesCondition: matchesCondition
    });

    return (
      isVisible &&
      !isOrderValueCard &&
      !isDisabled &&
      matchesCondition
    );
  });

  // if (firstValidVisibleCard) {
  //   console.log("✅ [Delivery Debug] Selecting card:", firstValidVisibleCard.dataset.variantName ||firstValidVisibleCard.dataset.title ||firstValidVisibleCard.innerText.trim());
  //   firstValidVisibleCard.click();

  // } 
  if (firstValidVisibleCard) {
    const rawPrice = firstValidVisibleCard
      .querySelector(".delivery-price")?.dataset.price;
    const price = rawPrice !== undefined ? Number(rawPrice) : NaN;
    if (price === 0) {
      firstValidVisibleCard.click();
    } else {
      // console.log("🚫 First eligible card is PAID. Not selecting it.");
    }
  }else {
    // console.warn("❌ [Delivery Debug] No eligible visible delivery card found.");
  }

} else {

  console.log(
    "ℹ️ [Delivery Debug] Existing selected card is still visible. Keeping selection."
  );

}

        updateLeadTimeHeader();

        // Re-evaluate the £15000+ order-value card's disabled/selected
        // state whenever the delivery grid is re-rendered/toggled.
        if (typeof window.updateOrderValueDeliveryCard === 'function') {
          window.updateOrderValueDeliveryCard();
        }

            
          }

  // ----------------------------------------------------
  // EVENTS
  // ----------------------------------------------------

  function bindVariantEvents() {

    document.querySelectorAll(
      'input[name="Desk Top Colour"], input[name="Desk Top Size(cm)"]'
    ).forEach((input) => {

      input.removeEventListener(
        'change',
        toggleLeadTimeCards
      );

      input.addEventListener('change', function () {

        setTimeout(() => {

          toggleLeadTimeCards();

        }, 300);

      });

    });

  }

  // ----------------------------------------------------
  // AJAX OBSERVER
  // ----------------------------------------------------

  const deliveryObserver = new MutationObserver(() => {

    setTimeout(() => {

      bindVariantEvents();
      toggleLeadTimeCards();

    }, 300);

  });

  const deliveryGrid = document.querySelector(
    '.delivery-grid'
  );

  if (deliveryGrid) {

    deliveryObserver.observe(deliveryGrid, {
      childList: true,
      subtree: true
    });
  }
  // ----------------------------------------------------
  // ACCESSORY OBSERVER
  // ----------------------------------------------------
  // Watches the custom_top_options slider, but only reacts when a
  // card's "active" class SPECIFICALLY changes (i.e. an accessory was
  // actually added/removed) -- not on every class attribute change.
  //
  // This matters because the product slider UI also toggles a
  // "left-aside" class on cards during normal rendering (prev/next
  // clicks, tab switches, window resize, ResizeObserver fit
  // recalculation). A plain "any class changed" observer picks up
  // those unrelated re-renders too, and re-running toggleLeadTimeCards()
  // on every one of them was force-clicking the free delivery card and
  // wiping out whatever delivery option the user had actually chosen.
  //
  // By diffing oldValue vs the current class list for "active"
  // specifically, we catch every real way an accessory can become
  // active/inactive (button click, modal select, porthole auto-add,
  // syncing duplicate cards across tabs, etc.) while ignoring
  // "left-aside" churn entirely.

  const accessorySlider = document.querySelector(
    '.accessory-slider[data-tab="custom_top_options"]'
  );

  if (accessorySlider) {

    const accessoryObserver = new MutationObserver((mutations) => {

      const activeStateChanged = mutations.some((m) => {
        if (m.attributeName !== 'class') return false;
        const el = m.target;
        if (!el.classList || !el.classList.contains('accessory-card')) return false;

        const wasActive = (m.oldValue || '').split(/\s+/).includes('active');
        const isActive = el.classList.contains('active');

        return wasActive !== isActive;
      });

      if (!activeStateChanged) return;

      setTimeout(() => {
        toggleLeadTimeCards();
      }, 200);
    });

    accessoryObserver.observe(accessorySlider, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  // ----------------------------------------------------
  // INITIAL LOAD
  // ----------------------------------------------------

   bindVariantEvents();
  toggleLeadTimeCards();

});


// ======================================================
// AIRFLOW ERGONOMIC TASK CHAIR — 3 WEEK LEAD TIME TOGGLER
// ONLY FOR AIRFLOW ERGONOMIC TASK CHAIR PRODUCT
// Colour = Black  -> show "3 week lead time" delivery cards only
// Colour = White (or anything else) -> show normal delivery cards only
// ======================================================

document.addEventListener('DOMContentLoaded', function () {

  const isAirflowProduct = window.location.pathname.includes('airflow-ergonomic-task-chair');
  if (!isAirflowProduct) return;

  const RESTRICTED_COLOUR = 'black';

  function getSelectedColour() {
    const input =
      document.querySelector('input[name="Colour"]:checked') ||
      document.querySelector('input[name="Color"]:checked');
    return (input?.value || '').trim().toLowerCase();
  }

  function isRestricted() {
    return getSelectedColour() === RESTRICTED_COLOUR;
  }

  function toggleAirflowLeadTimeCards() {

    const restricted = isRestricted();
    const deliveryCards = document.querySelectorAll('.delivery-card');

    deliveryCards.forEach((card) => {

      const variantName = (card.dataset.variantName || card.dataset.title || '').toLowerCase();
      const isLeadTimeCard =
        variantName.includes('3 week lead time') || variantName.includes('(3 week)');

      if (restricted) {
        if (isLeadTimeCard) {
          card.style.removeProperty('display');
        } else {
          card.style.setProperty('display', 'none', 'important');
        }
      } else {
        if (isLeadTimeCard) {
          card.style.setProperty('display', 'none', 'important');
        } else {
          card.style.removeProperty('display');
        }
      }
    });

    const currentlySelected = document.querySelector('.delivery-card.selected');
    const currentlySelectedStillVisible =
      currentlySelected &&
      window.getComputedStyle(currentlySelected).display !== 'none';

    if (!currentlySelectedStillVisible) {
      const freeVisibleCard = [...document.querySelectorAll('.delivery-card')].find((card) => {
        const isVisible = window.getComputedStyle(card).display !== 'none';
        const price = Number(card.querySelector('.delivery-price')?.dataset.price || 0);
        return isVisible && price === 0;
      });

      if (freeVisibleCard) {
        freeVisibleCard.click();
      }
    }

    if (typeof refreshDeliverySlider === 'function') {
      refreshDeliverySlider();
    }
  }

  function bindColourEvents() {
    document.querySelectorAll('input[name="Colour"], input[name="Color"]').forEach((input) => {
      input.removeEventListener('change', toggleAirflowLeadTimeCards);
      input.addEventListener('change', function () {
        setTimeout(toggleAirflowLeadTimeCards, 300);
      });
    });
  }

  const deliveryGrid = document.querySelector('.delivery-grid');
  if (deliveryGrid) {
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        bindColourEvents();
        toggleAirflowLeadTimeCards();
      }, 300);
    });
    observer.observe(deliveryGrid, { childList: true, subtree: true });
  }

  bindColourEvents();
  toggleAirflowLeadTimeCards();

});


document.addEventListener('DOMContentLoaded', function () {
  initDeliveryDots();
});
/* ============================================================
   DELIVERY SLIDER — DOTS
   ============================================================ */

// Call this again any time your JS shows/hides cards dynamically
// (e.g. after zone/postcode logic runs), so dots stay accurate.
function initDeliveryDots() {
  const section = document.getElementById('dynamic-delivery-options-section');
  const grid = document.querySelector('.delivery-grid');
  const dotsContainer = document.getElementById('deliveryDots');
  if (!section || !grid || !dotsContainer) return;

  if (window.innerWidth >= 1400) {
    dotsContainer.innerHTML = '';
    dotsContainer.style.display = 'none';
    return;
  }

  const visibleCards = Array.from(grid.querySelectorAll('.delivery-card'))
    .filter(card => {
      const style = window.getComputedStyle(card);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

  if (!visibleCards.length) {
    dotsContainer.innerHTML = '';
    dotsContainer.style.display = 'none';
    return;
  }

  const isSliding = grid.scrollWidth > grid.clientWidth + 2;

  if (!isSliding) {
    dotsContainer.innerHTML = '';
    dotsContainer.style.display = 'none';
    return;
  }

  dotsContainer.style.display = 'flex';
  dotsContainer.innerHTML = '';
  visibleCards.forEach((card, i) => {
    const dot = document.createElement('span');
    dot.className = 'dot' + (i === 0 ? ' active' : '');
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll('.dot');

  if (grid._deliveryScrollHandler) {
    grid.removeEventListener('scroll', grid._deliveryScrollHandler);
  }

  grid._deliveryScrollHandler = function () {
    const cardWidth = visibleCards[0].offsetWidth + 8;
    const index = Math.round(grid.scrollLeft / cardWidth);
    dots.forEach((d, i) => d.classList.toggle('active', i === index));
  };

  grid.addEventListener('scroll', grid._deliveryScrollHandler, { passive: true });
}


/* ============================================================
   DELIVERY SLIDER — PREV / NEXT NAV BUTTONS
   ============================================================ */

function initDeliveryNavButtons() {
  const grid = document.getElementById('deliveryGrid');
  const prevBtn = document.getElementById('deliveryPrevBtn');
  const nextBtn = document.getElementById('deliveryNextBtn');
  const container = document.querySelector('.delivery-slider-container');
  if (!grid || !prevBtn || !nextBtn || !container) return;

  function scrollByOneCard(direction) {
    const card = grid.querySelector('.delivery-card');
    if (!card) return;
    const gap = 8; // matches .delivery-grid gap
    const cardWidth = card.getBoundingClientRect().width + gap;
    grid.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', () => scrollByOneCard(-1));
  nextBtn.addEventListener('click', () => scrollByOneCard(1));

  function updateNavButtonState() {
    // Grid mode (≥1400px) — no slider at all
    if (window.innerWidth >= 1400) {
      container.classList.add('no-slide');
      return;
    }

    // Nothing to scroll (only 1-2 cards, all fit) — hide arrows entirely
    const isSliding = grid.scrollWidth > grid.clientWidth + 2;
    if (!isSliding) {
      container.classList.add('no-slide');
      return;
    }

    container.classList.remove('no-slide');
    const maxScroll = grid.scrollWidth - grid.clientWidth;
    prevBtn.disabled = grid.scrollLeft <= 2;
    nextBtn.disabled = grid.scrollLeft >= maxScroll - 2;
  }

  grid.addEventListener('scroll', updateNavButtonState, { passive: true });
  updateNavButtonState();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateNavButtonState, 150);
  });
}


/* ============================================================
   COMBINED REFRESH — call this after any dynamic card
   show/hide (zone logic, variant swap, etc.) instead of
   calling the two functions above separately.
   ============================================================ */

function refreshDeliverySlider() {
  initDeliveryDots();
  const grid = document.getElementById('deliveryGrid');
  if (grid) {
    grid.dispatchEvent(new Event('scroll')); // re-triggers updateNavButtonState via its listener
  }
}


/* ============================================================
   INIT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  initDeliveryDots();
  initDeliveryNavButtons();
});